module.exports = __webpack_public_path__ + "static/media/audible.260e2034.svg";